/**
 * Fund Finder — the tab row that switches the panels.
 *
 * Progressive enhancement: every panel is in the markup and all but the first
 * carry the hidden attribute, so the content is there with scripting off.
 */
document.querySelectorAll( '.block-fund-finder' ).forEach( ( block ) => {
	const tabs = Array.from( block.querySelectorAll( '[role="tab"]' ) );

	if ( tabs.length < 2 ) {
		return;
	}

	const select = ( tab ) => {
		tabs.forEach( ( other ) => {
			const panel = block.querySelector( '#' + CSS.escape( other.getAttribute( 'aria-controls' ) ) );
			const active = other === tab;

			other.setAttribute( 'aria-selected', active ? 'true' : 'false' );

			if ( panel ) {
				panel.hidden = ! active;
			}
		} );
	};

	tabs.forEach( ( tab, index ) => {
		tab.addEventListener( 'click', () => select( tab ) );

		// Left/right walk the row, which is what a tablist is expected to do.
		tab.addEventListener( 'keydown', ( event ) => {
			if ( event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' ) {
				return;
			}

			event.preventDefault();

			const step = event.key === 'ArrowRight' ? 1 : -1;
			const next = tabs[ ( index + step + tabs.length ) % tabs.length ];

			select( next );
			next.focus();
		} );
	} );
} );
